'use client'
import FormHelper from "@components/form/form"
import { Blockquote, Title, Text, Button } from "@mantine/core";
import { IconArrowBack, IconCircleCheck } from "@tabler/icons-react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import * as yup from 'yup'
import { PayloadForgotPassword } from "./types";
import { useMutation } from "react-query";
import { ForgotPasswordMutations } from "./rest-api";
import { createNotification, useCustomNotification } from "utils/notifications/notifications";
import { useState } from "react";
import { formatTaxID } from "app/auth/(register)/register/form/separate-components/input-container-tax-id";

const validationSchema = yup.object().shape({
    direct_url: yup.string(),
    // npwp: yup.string().required("NPWP / Tax ID is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
});

export default function ForgotPassword() {
    const { t } = useTranslation('login');
    const redirectURI = encodeURI(
        process.env.NEXT_PUBLIC_REDIRECT_FORGOT_PASSWORD || ""
    )
    const [successSendRequest, setsuccessSendRequest] = useState(false)
    const { notify } = useCustomNotification()
    const handleSubmit = async (values: PayloadForgotPassword) => {
        try {
            const fingerprint = localStorage.getItem("fingerprint") || undefined
            values.direct_url = redirectURI
            values.fingerprint = fingerprint || ''
            return await FPmutation.mutateAsync({ payload: values });
        } catch (error) {
            console.error(error)
        }
    }

    const FPmutation = useMutation({
        mutationFn: async ({ payload }: { payload: PayloadForgotPassword }) =>
            ForgotPasswordMutations.RequestForgotPassword(payload),
        onSuccess: () => {
            setsuccessSendRequest(true)
            createNotification({
                type: 'success',
                title: 'Success',
                message: "Link to reset password has been sent to your email",
                autoClose: 2000,
            })
        },
        onError: (error) => {
            console.error(error)
            notify(error)
        },
    });


    return (
        <div className="flex flex-col p-8 gap-2 w-full">
            <Link href={"/auth/login"}>
                <div className="font-bold  flex-grow float-left text-white p-2 bg-tripatra-9 rounded">
                    <div className="flex gap-2">
                        <IconArrowBack size={20} />
                        {t('back')}
                    </div>
                </div>
            </Link>
            <Title order={3} classNames={{ root: 'text-tripatra-9 font-semibold' }}> {t('forgotPassword')} </Title>
            {!successSendRequest ? (
                <>
                    <FormHelper validationSchema={validationSchema} onSubmit={handleSubmit}>
                        {({ Field, watch }) => {
                            // const taxId = watch('npwp')
                            return (
                                // todo: uncomment this when npwp is available
                                <div>
                                    {/* <Field.Text
                                        label="NPWP / Tax ID"
                                        placeholder="NPWP / Tax ID"
                                        name="npwp"
                                        description={t('npwpDescription')}
                                        value={taxId ? formatTaxID(taxId) : taxId}
                                        maxLength={24}
                                        className="mb-2"
                                    /> */}
                                    <Field.Text label="Email" placeholder="Email" name="email" />
                                    <Button type="submit" className="bg-tripatra-8 w-full mt-4 hover:bg-tripatra-9 text-white font-bold py-1 px-4 rounded" loading={FPmutation.isLoading}>
                                        {t('form.submit').toUpperCase()}
                                    </Button>
                                </div>
                            )
                        }}
                    </FormHelper>
                </>
            ) : (
                <>
                    <Blockquote color={'green'} cite="" icon={<IconCircleCheck />} mt="xl">
                        <Text size="xl" c={'green'}>{t('successTitleSendRequestForgotPassword')}</Text>
                        <Text size="lg">{t('successSendRequestForgotPassword')}</Text>
                    </Blockquote>
                </>
            )}
        </div>
    )
}
